
import { defineComponent } from 'vue';

export default defineComponent({
    name: "TileDisplay",

    props:[
        "data"
    ]

});
